var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "11px",
    viewBox: "0 0 17 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DDF23D1F-0C9E-44C8-AE57-5986AC20D48D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Relationship-Details",
    transform: "translate(-1388.000000, -87.000000)",
    fill: "#992BB8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(1388.652588, 87.045636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12163719,0 C11.1621736,0 14.0718623,2.23591378 15.9940667,4.55872593 C16.3270938,4.96139672 16.3253746,5.54352201 15.9940667,5.94409848 C15.5111244,6.52769292 14.4986646,7.65424588 13.146426,8.63857308 C9.73335186,11.12321 6.5024205,11.1177398 3.09684843,8.63857308 C1.74460978,7.65424588 0.732150014,6.52769292 0.249207642,5.94409848 C-0.0830692139,5.54274055 -0.0830692139,4.96008386 0.249207642,4.55872593 C2.17013047,2.2374767 5.08050687,0 8.12163719,0 Z M8.12163719,1.75047074 C6.19111804,1.75047074 4.62069572,3.32089305 4.62069572,5.25141221 C4.62069572,7.18193136 6.19111804,8.75235368 8.12163719,8.75235368 C10.0521563,8.75235368 11.6225787,7.18193136 11.6225787,5.25141221 C11.6225787,3.32089305 10.0521563,1.75047074 8.12163719,1.75047074 Z M8.12163719,2.75073973 C9.50272047,2.75073973 10.6223097,3.87032893 10.6223097,5.25141221 C10.6223097,6.63249548 9.50272047,7.75208469 8.12163719,7.75208469 C6.74055392,7.75208469 5.62096471,6.63249548 5.62096471,5.25141221 C5.62096471,3.87032893 6.74055392,2.75073973 8.12163719,2.75073973 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewNew);
export default __webpack_public_path__ + "static/media/viewNew.0be48e5c2b069c3a46fba34e843e761e.svg";
export { ForwardRef as ReactComponent };